import React, { useState } from "react";
import {
  Bar,
  BoldText,
  Icon,
  IconText,
  IconTextWrapper,
  IconsWrapper,
  Logo,
  ReloadIcon,
  Text,
  TextWrapper,
} from "./Appbar.style";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE, PRIVATE_ROUTE, } from "@router/route.constants";
import {
  SearchOutlined,
  DownloadOutlined,
  PlusOutlined,
  BalanceLoading,
} from "@assets";
import { useTranslation } from "react-i18next";
import { getFormattedNumber } from "@utils";
import { useDispatch, useSelector } from "react-redux";
import Lottie from "react-lottie";
import { TOPUP_LK } from "@constants";
import { setOpenLoginAlert, saveUser } from "@redux/auth/authSlice";
import { api } from "@api";

const Appbar = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.auth.token);
  const { main_balance, bonus, is_in_game, can_exit_check } = useSelector(
    (state) => state.auth.user
  );
  const [loading, setLoading] = useState(false);

  const goToSearch = () => {
    navigate(`/${PUBLIC_ROUTE.SEARCH}`);
  }

  const goToDownload = () => {
    navigate(`/${PUBLIC_ROUTE.APP_DOWNLOAD}`);
  }

  const goToTopUp = (e) => {
    if (!checkIsLoggedIn()) {
      return;
    }
    navigate(`/${PRIVATE_ROUTE.ACCOUNT_TYPE}/${TOPUP_LK}`);
  };

  const goToWallet = () => {
    if (!checkIsLoggedIn()) {
      return;
    }
    navigate(`/${PUBLIC_ROUTE.HOME}/${PRIVATE_ROUTE.WALLET}`);
  };

  const checkIsLoggedIn = () => {
    if (!isLoggedIn) {
      dispatch(setOpenLoginAlert(true));
    }
    return isLoggedIn;
  };

  const checkExit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!loading) {
      setLoading(true);
      api
        .checkExit()
        .then(({ user }) => {
          dispatch(saveUser(user));
          // save user to localstorage
          localStorage.setUser(user);
        })
        .catch(() => { });
    }
  }

  return (
    <Bar>
      <Logo />

      <TextWrapper>
        <Text onClick={goToWallet}>
          {t("wallet.walletMyBalance")}
        </Text>
        <BoldText onClick={goToWallet}>
          {can_exit_check && <ReloadIcon onClick={checkExit} />}
          {is_in_game
            ? (
              <Lottie
                options={{
                  animationData: BalanceLoading,
                }}
                width={32}
                height={16}
                style={{
                  position: 'absolute',
                  top: '50%',
                  right: '0',
                }}
              />
            )
            : getFormattedNumber(main_balance + bonus)
          }
        </BoldText>
      </TextWrapper>

      <IconsWrapper>
        <IconTextWrapper onClick={goToTopUp}>
          <PlusOutlined />
          <IconText>
            {t("wallet.walletTopUp")}
          </IconText>
        </IconTextWrapper>
        <Icon onClick={goToDownload}>
          <DownloadOutlined />
        </Icon>
        <Icon onClick={goToSearch} >
          <SearchOutlined />
        </Icon>
      </IconsWrapper>
    </Bar>
  );
};

export default Appbar;
